export const MATCHER_CONFIG_WARNING_MESSAGE =
  'Matcher configuration warning: Critical qualifier configuration was not fully loaded for this run. Covered overrides were disabled or limited, so coverage may be conservative.';

export const shouldShowMatcherConfigWarning = (matchingMetadata) => {
  const status = matchingMetadata?.qualifier_config_status;
  return Boolean(status && status !== 'loaded');
};

export const getMatcherConfigWarningDetails = (matchingMetadata) => {
  if (!shouldShowMatcherConfigWarning(matchingMetadata)) {
    return null;
  }
  const parts = [`Status: ${matchingMetadata.qualifier_config_status}`];
  if (matchingMetadata?.qualifier_config_version) {
    parts.push(`Config version: ${matchingMetadata.qualifier_config_version}`);
  }
  return parts.join(' · ');
};
